import React from 'react';

interface MobileBottomActionBarProps {
  onBuySellClick: (side: 'buy' | 'sell') => void;
}

const MobileBottomActionBar: React.FC<MobileBottomActionBarProps> = ({
  onBuySellClick
}) => {
  return (
    <div className="bg-white border-t border-gray-200 px-4 py-3 flex-shrink-0">
      <div className="flex gap-3">
        <button
          onClick={() => onBuySellClick('buy')}
          className="flex-1 py-3 bg-green-600 text-white font-semibold rounded transition-colors hover:bg-green-700"
        >
          Buy / Long
        </button>
        <button
          onClick={() => onBuySellClick('sell')}
          className="flex-1 py-3 bg-red-600 text-white font-semibold rounded transition-colors hover:bg-red-700"
        >
          Sell / Short
        </button>
      </div>
    </div>
  );
};

export default MobileBottomActionBar;
